import { Checkbox } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as R from 'ramda'
import * as React from 'react'

import { dispatch } from '../../store'
import itemStyles from './lecture-item.scss'
import styles from './lecture-type-checkbox.scss'
const cx = classnames.bind({ ...styles, ...itemStyles })
const initialType = [
  {
    label: {
      title: '商學',
      brief: ' ( 金融、商業、行銷、創新、管理學 )'
    },
    value: '商學',
    active: false
  },
  {
    label: {
      title: '社會科學',
      brief: ' ( 心理學、社會學、人類學、經濟學 )'
    },
    value: '社會科學',
    active: false
  },
  {
    label: {
      title: '個人成長',
      brief: ' ( 人脈、時間管理、壓力管理、健康、領導、職能 )'
    },
    value: '個人成長',
    active: false
  },
  {
    label: {
      title: '人文',
      brief: ' ( 設計、藝術、文學、哲學 )'
    },
    value: '人文',
    active: false
  },
  {
    label: {
      title: '科技',
      brief: ' ( 工程、科學、科技 )'
    },
    value: '科技',
    active: false
  },
  {
    label: {
      title: '生活',
      brief: ' ( 理財、旅遊、成長、娛樂 )'
    },
    value: '生活',
    active: false
  }
]


interface IType {
  active: boolean,
  value: string,
  label: {
    title: string,
    brief: string
  }
}
interface IProps {
  isEdit: boolean,
  lectureId: string,
  tags: string[]
}

interface IState {
  isEnabled?: boolean,
  typeList: IType[]
}

class LectureContent extends React.Component<IProps, IState> {
  public state: IState = {
    isEnabled: false,
    typeList: []
  }
  public componentDidMount = () => {
    this.setState({typeList: initialType})
  }

  public componentWillReceiveProps = (nextprops:IProps) => {
    const { tags } = nextprops
    const { typeList } = this.state

    if (tags && !R.isEmpty(typeList)) {
      typeList.map((item) => ({ ...item, active: false }))
      tags.forEach((tag:string) => {
        const idx = typeList.findIndex(item => item.value === tag)// parseInt(tag, 10)
        typeList[idx].active = true
      })
      this.setState({ typeList })
    }
  }
  public handleEnabledChange = (id:number) => {
    const { typeList } = this.state
    const { lectureId } = this.props
    typeList[id].active = !typeList[id].active
    this.setState({ typeList })
    
    const tags = typeList.filter(item => item.active).map((item) => item.value)
    dispatch.lectures.updateLecture({
      lectureId, updated: { tags }
    })
  }
  public render() {
    const { typeList } = this.state
    return (
      <div className={cx('checkbox_section')}>
      <h3>講座分類</h3>
      {
        typeList.map((item:any, id:number) =>
          <div key={id} className={cx('checkbox_wrapper')}>
            {/* tslint:disable-next-line jsx-no-lambda */}
            <Checkbox key={id} checked={item.active} onChange={() => this.handleEnabledChange(id)}>
              <strong>{item.label.title}</strong>{item.label.brief}
            </Checkbox>
          </div>
        )
      }
      </div>
    )
  }
}

export default LectureContent


// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-type-checkbox.tsx